import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

if (process.env.VUE_APP_APP_ENV !== 'test') {
  Bugsnag.start({
    apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
    releaseStage: process.env.VUE_APP_APP_ENV,
    enabledReleaseStages: ['production', 'staging'],
    plugins: [new BugsnagPluginVue()],
  });

  Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);
  Bugsnag.leaveBreadcrumb('App starting…');
}
